module.exports = __webpack_public_path__ + "static/img/defaultImage.6e0a8afc.jpeg";